import React from 'react';

import { Button, LoadingButton, Modal } from '@common/index';
import { Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, State, flowActions } from '@store/index';

import { Warning } from '@mui/icons-material';
import { useTheme } from '../../styles/theme';
import { useParams } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { deleteWorkspaceRole } from '@requests/roles';

export const DeletePermissionGroup: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const theme = useTheme();
  const queryClient = useQueryClient();

  const { service_id } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const permissionGroupId = useSelector((state: State) => state.flow.deletePermissionGroup);
  const modalOpen = Boolean(permissionGroupId);

  const { mutateAsync: deleteGroup, isPending: isRemoveLoading } = useMutation({
    mutationFn: deleteWorkspaceRole,
    onSuccess: (data) => {
      if (data?.error) {
        enqueueSnackbar('Failed to delete permission group!', {
          variant: 'error',
          autoHideDuration: 10000,
        });

        enqueueSnackbar(data?.error, {
          variant: 'error',
          autoHideDuration: 10000,
        });

        return;
      }

      queryClient.invalidateQueries({ queryKey: ['groups'] });
      dispatch(flowActions.setDeletePermissionGroup(null));
    },
  });

  const deleteWorkspacePermissionGroup = async () => {
    await deleteGroup({ serviceId: service_id as string, roleId: permissionGroupId });
  };

  return (
    <Modal
      open={modalOpen}
      setOpen={(val) => dispatch(flowActions.setDeletePermissionGroup(val))}
      header='Delete Group Permission'
      background={theme.telnyx.red}
      icon={<Warning />}
      info='Are you sure you want to delete this permission group? This action cannot be undone.'
      actions={
        <Stack direction='row' spacing={1}>
          <Button small onClick={() => dispatch(flowActions.setDeletePermissionGroup(null))}>
            Cancel
          </Button>
          <LoadingButton
            loading={isRemoveLoading}
            minWidth='70px'
            small
            customColor='red'
            onClick={deleteWorkspacePermissionGroup}
          >
            Delete
          </LoadingButton>
        </Stack>
      }
    />
  );
};
